export const REPONT_CONSTANT = 'repont';
export const AUTOMATED_REPONT_CONSTANT = 'automated';
export const MANUAL_REPONT_CONSTANT = 'manual';